var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import './style.scss';
import { createRoot } from 'react-dom/client';
import { useCallback, useRef, useState } from 'react';
import ImportAxios from '@themes/common/axios';
import { FormatMoney } from '@components/Shared/Utils/price';
import RefreshIcon from '@mui/icons-material/Refresh';
import clsx from 'clsx';
import { GetCommonSettings } from '@themes/common/data';
import { TransitionGroup } from 'react-transition-group';
import Collapse from '@mui/material/Collapse';
import ShopifyAjaxApi from '@themes/common/shopifyApi';
import AppProvider from '@components/Shared/State/provider';
import useProductPage from '@themes/product/useProductPage';
const ShippingCalculator = ({ isProductPage }) => {
    const [{ product, quantity }] = useProductPage(0, 0, [], null, false, false);
    const { translations: { cart: cartTranslation }, } = GetCommonSettings();
    const triggred = useRef(false);
    const { calculate_shipping, zip, no_rates, calculate } = (cartTranslation === null || cartTranslation === void 0 ? void 0 : cartTranslation.shipping) || {};
    const [loading, setLoading] = useState(false);
    const [postalCode, setPostalCode] = useState('');
    const [shippingRates, setShippingRates] = useState(null);
    const caclulateShipping = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        if (!postalCode) {
            setShippingRates([]);
            return;
        }
        setLoading(true);
        try {
            const axios = yield ImportAxios();
            // Use provided items if available, otherwise fetch cart items
            const cartItems = isProductPage
                ? [
                    {
                        variant_id: product.variant_id,
                        quantity,
                        price: (product === null || product === void 0 ? void 0 : product.price) || 0,
                        name: (product === null || product === void 0 ? void 0 : product.title) || '',
                        sku: (product === null || product === void 0 ? void 0 : product.sku) || '',
                        vendor: (product === null || product === void 0 ? void 0 : product.vendor) || '',
                        grams: (product === null || product === void 0 ? void 0 : product.weight) || 0,
                    },
                ]
                : (yield ShopifyAjaxApi.Cart()).items;
            const response = yield axios.post('https://api.advancedshippingrules.com/rates', {
                destination: {
                    postal_code: postalCode.trim().replace(/\s/g, ''),
                    country: globalThis.Shopify.country,
                },
                items: cartItems.map((item) => (Object.assign(Object.assign({}, item), { fulfillment_service: 'manual' }))),
            }, {
                auth: {
                    username: process.env.ADVANCE_SHIPPING_API_ID,
                    password: process.env.ADVANCE_SHIPPING_API_KEY,
                },
            });
            if (Array.isArray(response.data)) {
                setShippingRates((_a = response.data) !== null && _a !== void 0 ? _a : []);
            }
            else {
                setShippingRates([]);
            }
        }
        catch (error) {
            console.error('Error calculating shipping rates:', error);
            setShippingRates([]);
        }
        setLoading(false);
    }), [isProductPage, postalCode, product, quantity]);
    return (_jsxs("div", Object.assign({ className: 'shipping-calculator--container' }, { children: [_jsx("h3", Object.assign({ className: 'heading' }, { children: calculate_shipping })), _jsxs("div", Object.assign({ className: 'shipping-calculator--wrapper' }, { children: [_jsxs("div", Object.assign({ className: 'shipping-calculator--form-wrapper' }, { children: [_jsxs("div", Object.assign({ className: 'flex gap-1 flex-col' }, { children: [_jsx("label", Object.assign({ htmlFor: 'zip', className: 'text-sm font-bold' }, { children: zip })), _jsx("input", { id: 'zip', type: 'text', name: 'zip', value: postalCode, disabled: loading, onChange: (e) => setPostalCode(e.target.value) })] })), _jsxs("button", Object.assign({ type: 'button', className: clsx('button-secondary button ripple with-loading', {
                                    'loading disabled': loading,
                                }), disabled: loading, onClick: () => {
                                    triggred.current = true;
                                    caclulateShipping();
                                } }, { children: [_jsx("span", Object.assign({ className: 'button--text' }, { children: calculate })), _jsx("span", Object.assign({ className: 'loading--icon' }, { children: _jsx(RefreshIcon, {}) }))] }))] })), shippingRates != null && (_jsx(_Fragment, { children: _jsxs(TransitionGroup, Object.assign({ className: 'shipping--list' }, { children: [shippingRates.map((rate, index) => (_jsx(Collapse, Object.assign({ in: true }, { children: _jsxs("div", Object.assign({ className: 'shipping--list-item' }, { children: [_jsxs("div", { children: [_jsx("div", Object.assign({ className: 'shipping--title' }, { children: rate.service_name })), rate.description && _jsx("div", Object.assign({ className: 'shipping--subtitle' }, { children: rate.description }))] }), _jsx("div", Object.assign({ className: 'shipping--price' }, { children: FormatMoney(rate.total_price) }))] })) }), `${rate.service_name}-${index}`))), shippingRates.length === 0 && (_jsx(Collapse, Object.assign({ in: true }, { children: _jsx("div", Object.assign({ className: 'shipping--list-item no-shipping' }, { children: no_rates })) }))), _jsx("div", { className: 'shipping-calculator--divider' })] })) }))] }))] })));
};
export default function LoadDeliveryTime(element, props = {}) {
    const rootDom = createRoot(element);
    const jQueryElement = jQuery(element);
    const data = jQueryElement.data();
    rootDom.render(_jsx(AppProvider, { children: _jsx(ShippingCalculator, Object.assign({}, props, { isProductPage: !!data.variantId })) }));
}
